import { Box, Button, Stack, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import { ROUTES } from "constants/routes";
import { useNavigate } from "react-router-dom";

const LogoutConfirmation = ({ showDialog, setShowDialog }: any) => {
  const navigate = useNavigate();
  return (
    <CustomDialog
      showDialog={showDialog}
      setShowDialog={setShowDialog}
      fullScreenOnMobile={false}
      dialogProps={{ maxWidth: "sm", fullWidth: false }}
    >
      <Box sx={{ px: 3, py: 3 }}>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: "18px",
            fontWeight: 600,
            lineHeight: "24px",
            textAlign: "center",
          }}
        >
          Are you sure you want to logout? You will be missed!
        </Typography>

        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          mt={3}
        >
          <Button
            sx={{
              backgroundColor: "transparent",
              color: "primary.main",
              border: "1px solid #dfdfdf",
            }}
            variant="contained"
            type="submit"
            onClick={() => setShowDialog(false)}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={() => navigate(ROUTES.LOGOUT)}>
            Yes, I’m Sure
          </Button>
        </Stack>
      </Box>
    </CustomDialog>
  );
};

export default LogoutConfirmation;
